import { Td, type StackProps } from '@chakra-ui/react';

export type UiTdProps = StackProps;

export const UiTd = Td;
